<h1 class="title">Åtgärdslista</h1>
<p class="brodtext-medium-14">
  Okända namn är namn på smittämnen, analyser, provtyper eller antibiotika som inte känns igen av Svebar. Det räcker med <br>
  en punkt eller stor bokstav som skillnad för att okända namn ska identifieras. Dessa behöver hanteras manuellt i <br>
  Svebar via en synonymiseringsprocess som utförs av administratörer på Fohm. Varje enskilt kliniskt mikrobiologiskt <br>
  laboratorium har sina egna listor för synonymisering.
</p>
<app-table
  [config]="tableConfig"
  [loading]="loading"
  [lazy]="true"
  [totalRecordsLazy]="paginationLength"
  [pagination]="paginationLength !== undefined && paginationLength !== 0"
  (sortEvent)="sort($event)"
>
</app-table>
